<template>
  <div class="container-fluid">
    <div class="loading" v-if="isLoading">Loading&hellip;</div>
    <div class="view-header my-4">
      <div class="view-header__main">
        <div class="view-header__info">
          <h1 class="view-header__title">Combos</h1>
          <p class="view-header__subtitle">Listas de productos que se venden juntas. El precio se calcula siempre con el precio actual de cada producto.</p>
        </div>
        <div class="view-header__actions">
          <router-link :to="{ name: 'Nuevo combo' }" class="btn view-header__btn view-header__btn--primary">
            <i class="bi bi-plus-lg"></i>
            Nuevo combo
          </router-link>
        </div>
      </div>
    </div>

    <div class="filters-panel">
      <div class="filters-panel__section">
        <div class="filters-panel__section-title">
          <i class="bi bi-search"></i>
          Buscador
        </div>
        <div class="filters-panel__row">
          <div class="filters-panel__field">
            <input v-model="search" type="search" class="form-control" placeholder="Buscar combo...">
          </div>
        </div>
      </div>
    </div>

    <div class="data-table">
      <table class="table mb-0">
        <thead>
          <tr>
            <th>Última modificación</th>
            <th>Nombre</th>
            <th>Productos</th>
            <th>Precio actual</th>
            <th>Estado</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="bundle in filteredBundles" :key="bundle.id">
            <td>{{ formatoDate2Fecha(bundle.updated_at) }}</td>
            <td>{{ bundle.name }}</td>
            <td>{{ bundle.products_count }} productos</td>
            <td>{{ formatoDinamicoMoneda(bundle.total, 'display') }}</td>
            <td>
              <span class="combos-status" :class="bundle.active ? 'combos-status--active' : 'combos-status--inactive'">
                {{ bundle.active ? 'Activo' : 'Inactivo' }}
              </span>
            </td>
            <td>
              <div class="table-action-group">
                <button
                  type="button"
                  class="table-action-btn"
                  :disabled="!bundle.active"
                  title="Convertir en venta"
                  aria-label="Convertir en venta"
                  @click="convertToSale(bundle)"
                >
                  <i class="bi bi-basket"></i>
                </button>
                <router-link :to="{ name: 'Editar combo', params: { bundleId: bundle.id } }" class="table-action-btn" title="Editar" aria-label="Editar">
                  <i class="bi bi-pencil"></i>
                </router-link>
                <button
                  type="button"
                  class="table-action-btn"
                  title="Eliminar"
                  aria-label="Eliminar"
                  @click="deleteBundle(bundle)"
                >
                  <i class="bi bi-trash"></i>
                </button>
              </div>
            </td>
          </tr>
          <tr v-if="!isLoading && filteredBundles.length === 0">
            <td colspan="6" class="text-center text-muted">No hay combos cargados.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import formatMoneyMixin from "../../../mixins/formatMoneyMixin";
import formatDateMixin from "../../../mixins/formatDateMixin";

export default {
  mixins: [formatMoneyMixin, formatDateMixin],
  data: function () {
    return {
      isLoading: false,
      search: '',
      bundles: [],
    };
  },
  computed: {
    filteredBundles() {
      if (!this.search) return this.bundles;
      const term = this.search.toLowerCase();
      return this.bundles.filter((bundle) => bundle.name.toLowerCase().includes(term));
    },
  },
  mounted() {
    this.loadBundles();
  },
  methods: {
    loadBundles() {
      this.isLoading = true;
      axios.get('/api/bundles/list')
        .then((response) => {
          this.bundles = response.data.data;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    convertToSale(bundle) {
      if (!bundle.active) return;
      this.$router.push({ name: 'Nueva venta desde combo', params: { bundleId: bundle.id } }).catch(() => {});
    },
    deleteBundle(bundle) {
      if (!confirm('¿Seguro que querés eliminar este combo?')) return;

      axios.post('/api/bundles/delete', { id: bundle.id }).then(() => {
        this.bundles = this.bundles.filter((item) => item.id !== bundle.id);
      }).catch(() => {
        alert('No se pudo eliminar el combo.');
      });
    },
  },
};
</script>

<style scoped>
.combos-status {
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 999px;
}
.combos-status--active {
  background: #E7F3EF;
  color: #1F6F63;
}
.combos-status--inactive {
  background: #F1F0EA;
  color: #726E66;
}
</style>
